国家信息填写组件
<template>
  <el-form-item :label="title" :id="field.FIELD_ID" :ref="field.FIELD_ID" :class="itemClass" v-show="isShow"
    :prop="field.FIELD_ID" :rules="rules">
    <div class="input country-input" :class="isDisabled ? 'is-disabled' : ''" @click="click($event)">
      <el-input v-model="showVal" :disabled="(showCountrySelect || isDisabled) ? true : false" :placeholder="field.PLACE_HOLDER"></el-input>
    </div>
    <country-select v-if="showCountrySelect" :countryList="options" @checkCountry="checkCountry" @close="close()">
    </country-select>
  </el-form-item>
</template>
<script>
import countrySelect from "./countrySelect";
export default {
  data () {
    return {
      showVal: "",
      isDisabled: false,
      itemClass: "self-countryPick",
      rules: [],
      triggerType: "custom",
      options: [],
      all_options: [],
      showCountrySelect: false,
    };
  },
  props: ["field", "index", "isBaseUI"],
  created () {
    this.rules.push({
      validator: this.validatorField,
      trigger: this.triggerType
    });
  },
  components: {
    countrySelect
  },
  mounted () {
    this.itemClass += " " + this.field.FIELD_ID;

    if (this.isRequired) this.itemClass += " self-countryPick-required";

    this.initDict();
    this.initData();
  },
  destroyed () { },
  computed: {
    isShow: function () {
      let fieldControl = parseInt(this.field.FIELD_CONTROL);
      if (fieldControl == 2) {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }

      if (fieldControl === 0 || fieldControl === 2) {
        return true;
      } else {
        return false;
      }
    },
    isRequired: function () {
      return parseInt(this.field.FIELD_REQUIRED) ? true : false;
    },
    title: function () {
      this.field.FIELD_TITLE =
        (this.field.FIELD_TITLE &&
          this.field.FIELD_TITLE.replace("\\n", "\n")) ||
        "";
      return _.trim(this.field.FIELD_TITLE)
        ? this.field.FIELD_TITLE +
        (_.intersection(this.field.FIELD_TITLE.split(""), ["：", ":"])
          .length
          ? ""
          : "：")
        : "";
    },
    dataChange: function () {
      return this.field.DEFAULT_VALUE;
    },
    messageChange: function () {
      return this.field.message;
    },
    dictFilterChange: function () {
      return this.field.FIELD_DICT_FILTER;
    },
    dictNameChange: function () {
      return this.field.FIELD_DICT_NAME;
    },
  },
  watch: {
    isRequired: function (val) {
      if (val) {
        this.itemClass += " self-countryPick-required";
      } else {
        this.itemClass = this.itemClass.replace(
          /self-countryPick-required/g,
          ""
        );
      }
      //ljc:保证在将字段从必填到非必填时触发
      this.$refs[this.field.FIELD_ID].validate("custom");
    },
    messageChange: function (val) {
      // if(val){
      this.$refs[this.field.FIELD_ID].validate("custom"); // 自定义触发校验事件
      // }
    },
    dataChange: function (val) {
      this.initData();

      this.field.message = "";

      this.$refs[this.field.FIELD_ID].validate("custom"); // 自定义触发校验事件

    },
    dictFilterChange: function (val) {

      this.initDict();
      this.initData();
    },
    dictNameChange: function (val) {
      this.initDict();
      this.initData();
    },
  },
  methods: {
    initDict () {
      if (this.field.FIELD_DICT_NAME && this.field.FIELD_DICT_NAME != "") {
        this.options = [];
        let showArr;
        try {
          let filter = eval(this.field.FIELD_DICT_FILTER);
          if (filter.constructor == Array) {
            showArr = filter;
          } else {
            showArr = [];
          }
        } catch (exception) {
          showArr = [];
        }

        _.forEach(this.field.FIELD_DICT_NAME, (item) => {
          // 判断机构ORG_CODE TODO 
          //默认显示字典名称
          let newName = item.DICT_ITEM_NAME;
          let obj = Object.assign(item, { "value": item.DICT_ITEM, "label": newName });
          if (!showArr.length || showArr.length == this.field.FIELD_DICT_NAME.length) {
            //如果不用过滤,直接添加
            this.options.push(obj);
            this.all_options.push(obj);
          } else {
            //如果需要过滤，则满足条件添加
            if (showArr && showArr.indexOf(item.DICT_ITEM) !== -1) {
              this.options.push(obj);
              this.all_options.push(obj);
            }
          }
        });

      }
    },
    initData () {
      if (this.field.DEFAULT_VALUE) {
        this.showVal = _.find(this.field.FIELD_DICT_NAME, (item) => {
          return item.DICT_ITEM == this.field.DEFAULT_VALUE;
        }).DICT_ITEM_NAME;
      } else {
        this.showVal = "";
      }
    },
    validatorField: function (rule, value, callback) {
      //隐藏的字段不校验
      // if(!this.isShow){
      //   return;
      // }
      value = this.field.DEFAULT_VALUE;
      if (_.trim(value) === "" && this.isRequired && this.isShow) {
        this.showErrorMsg = this.field.FIELD_TITLE + "为必填项";
        this.field.correct = false;
        this.field.showerr = true;
        this.field.FIELD_CONTROL = "0";
        return callback(new Error(this.showErrorMsg));
      } else if (this.field.message) { // 关联逻辑判断中传过来要显示的message
        this.showErrorMsg = this.field.message;
        this.field.correct = false;
        this.field.showerr = true;
        return callback(new Error(this.showErrorMsg));
      } else {
        this.field.correct = true;
        this.showErrorMsg = "";
        this.field.message = "";
        this.field.showerr = false;
        if (this.isBaseUI) {
          this.$emit("field-change", this.field);
        } else {
          this.$store.commit(this.$types.UPDATE_FIELD_CHANGE, { field_id: this.field.FIELD_ID, module_id: this.field.MODULE_ID, index: this.index });
        }
        return callback();
      }
    },
    click () {
      if (!this.isDisabled) {
        this.showCountrySelect = true;
      }
    },
    checkCountry (val) {
      if (val && val.selectVal) {
        this.field.DEFAULT_VALUE = val.selectVal;
      }
      this.showCountrySelect = false;

    },
    close () {
      this.showCountrySelect = false;
    }
  }
};
</script>

<style lang="less">
@import "~@/styles/less/variable.less";
.self-countryPick {
  width: 100%;
  display: flex;
  .el-form-item__content {
    flex: 1;
    .input {
      position: relative;
      display: inline-flex;
      width: 100%;
      .el-input {
        display: inline-flex;
        flex: 1;
        &.is-disabled {
          .el-input__inner {
            color: #232323 !important;
            // 注释原有格式，以下:
            // background: linear-gradient(180deg, #eff3f5, #f6f7f9) !important;
            // border: 2px solid #a7acbd !important;
            // box-shadow: inset 2px 2px 2px 0px rgba(39, 57, 96, 0.2),
              // inset -2px -2px 2px 0px rgba(39, 57, 96, 0.2) !important;
          }
        }
      }
      &.is-disabled {
        .el-input {
          .el-input__inner {
            color: #b6bbc5 !important;
            background: #eaedf0 !important;
            border: 2px solid #cdcfd8 !important;
            box-shadow: none !important;
          }
        }
      }
    }
  }
}

.self-countryPick-required {
  .el-form-item__label:before {
    content: "*";
    color: #f56c6c;
    margin-right: 4px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/preEntry/countryPickItem.vue